import Input, { type InputProps } from '@atoms/Input';
import { Listbox, ListboxItem } from '@heroui/listbox';
import { type QuestionSuggestion } from '@lib/question-suggestions';
import { useEffect, useState } from 'react';

interface InputWithSuggestionsProps extends InputProps {
  suggestions: QuestionSuggestion[];
  handleSelectSuggestion?: (value: QuestionSuggestion) => void;
}

export const InputWithSuggestions = ({
  suggestions,
  handleSelectSuggestion = () => { },
  ...rest
}: InputWithSuggestionsProps) => {
  const [showSuggestions, setShowSuggestions] = useState(false);

  const handleFocusCapture = (isFocused: boolean, value: string) => {
    if (!isFocused) {
      setShowSuggestions(false);
      return;
    }

    if (
      !value ||
      value?.length === 0 ||
      suggestions.some(
        (suggestion) =>
          suggestion.question.toLowerCase().includes(value.toLowerCase()) &&
          suggestion.question.toLowerCase() !== value.toLowerCase()
      )
    ) {
      setShowSuggestions(true);
    } else {
      setShowSuggestions(false);
    }
  };
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    handleFocusCapture(isFocused, rest.value!);
  }, [isFocused, rest.value]);

  return (
    <div
      className="relative w-full"
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
    >
      <Input {...rest} />

      {suggestions.length > 0 && (
        <Listbox
          className={
            'absolute z-50 w-full bg-white dark:bg-grey-900 overflow-auto rounded-b-md text-default-900 shadow-xl ' +
            (showSuggestions ? 'block' : 'hidden')
          }
        >
          {suggestions.map((suggestion, index) => (
            <ListboxItem
              key={index}
              className="w-full"
              onClick={() => {
                handleSelectSuggestion(suggestion);
              }}
            >
              {suggestion.question}
            </ListboxItem>
          ))}
        </Listbox>
      )}
    </div>
  );
};
